import { BuyerPreferenceDocument } from "@onpreo/database";

export type BuyerPreferenceState = {
    currentBuyerPreference: BuyerPreferenceDocument;
};
export const initialBuyerPreferenceState = {
    currentBuyerPreference: null
};
